module.exports = __webpack_public_path__ + "static/media/icon-hand.4f729864.svg";